// extracted by mini-css-extract-plugin
module.exports = {"category":"bh_fq","wrapp":"bh_fr","category__wrapper":"bh_fs"};